import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { ApiConsumidorService } from 'src/app/dao/api-consumidor.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Consumidor } from 'src/app/model/consumidor';

@Component({
  selector: 'app-dados-ociosos',
  templateUrl: './dados-ociosos.page.html',
  styleUrls: ['./dados-ociosos.page.scss'],
})
export class DadosOciososPage implements OnInit {

  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  //pedidos: Pedido[] = [];
  //pedido: Pedido;

  user: string;
  pass: string;

  data1: string;
  data2: string;

  dataAtual;
  

  tipoPedido = "todos";
  tipoRelatorio;

  dataAtualFormatada;
  
  dataMesPassado;
  dataMesPassadoFormatada;
  dataMesPassado2;

  data15diaPassado;
  data15diaPassadoFormatada;
  data15dias2; 


  data3MesPassado;
  data3MesPassadoFormatada; 

  data6MesPassado;
  data6MesPassadoFormatada;

  data6MesPassado2;



  data1AnoPassado;
  data1AnoPassadoFormatada;

  data1AnoPassado2;

  status = [];

  data: any;
  mostrarData = false;
  tipoPesquisa = "mes";

  dataaux2;
  dataaux1;

  tipoPedido2 = "";
  dataPesquisada = new Date().toISOString().split('T')[0];

  quantidade = 0;

  teste;

  titulo;
  idConsumidor;

  consumidor: Consumidor;


  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    //private pedidoapi: PedidoService,
    private global: GlobalService,
    private router: Router,
    private apiconsumidor: ApiConsumidorService) { }


  ngOnInit() {
    this.consumidor = new Consumidor();


    this.data15diaPassado = new Date();
    this.data15diaPassado.setDate(this.data15diaPassado.getDate() - 15);
    this.data15diaPassadoFormatada = this.data15diaPassado.toISOString().split('T')[0];
    this.data15dias2 = new Date();
    this.data15diaPassado.setDate(this.data15diaPassado.getDate() - 365);
    this.data15dias2 = this.data15diaPassado.toISOString().split('T')[0];


  

    this.dataMesPassado = new Date();
    this.dataMesPassado.setDate(this.dataMesPassado.getDate() - 30);
    this.dataMesPassadoFormatada = this.dataMesPassado.toISOString().split('T')[0];
    this.dataMesPassado2 = new Date();
    this.dataMesPassado.setDate(this.dataMesPassado.getDate() - 365);
    this.dataMesPassado2 = this.dataMesPassado.toISOString().split('T')[0];

  
    

    this.data6MesPassado = new Date();
    this.data6MesPassado.setDate(this.data6MesPassado.getDate() - 180);
    this.data6MesPassadoFormatada = this.data6MesPassado.toISOString().split('T')[0];
    this.data6MesPassado2 = new Date();
    this.data6MesPassado.setDate(this.data6MesPassado.getDate() - 365);
    this.data6MesPassado2 = this.data6MesPassado.toISOString().split('T')[0];

   
    

    this.data1AnoPassado = new Date();
    this.data1AnoPassado.setDate(this.data1AnoPassado.getDate() - 365);
    this.data1AnoPassadoFormatada = this.data1AnoPassado.toISOString().split('T')[0];
    this.data1AnoPassado2 = new Date();
    this.data1AnoPassado.setDate(this.data1AnoPassado.getDate() - 365);
    this.data1AnoPassado2 = this.data1AnoPassado.toISOString().split('T')[0];

    this.dataAtual = new Date();
    this.dataAtualFormatada = this.dataAtual.toISOString().split('T')[0];

    this.loadStatus();

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.idConsumidor = idParam
      this.loadProd(idParam);
      //this.tipoRelatorio = idParam;
    }

    this.data1 = this.dataAtualFormatada;
    this.data2 = this.dataAtualFormatada;

  }

  ionViewWillEnter() {
    this.titulo = "Historico de Consumidor";
    if (this.tipoRelatorio === "prod") {
      this.titulo = "Ranking de Produtos";
    }

    if (this.tipoRelatorio === "prod2") {
      this.titulo = "Relatório de Produtos";
    }

    if (this.tipoRelatorio === "pedido") {
      this.titulo = "Relatório de Pedidos";
    }

    if (this.tipoRelatorio === "cliente") {
      this.titulo = "Relatório de Clientes";
    }
    this.loadPedidos();
    this.loadStatus();
  }

  async loadProd(id: string) {
    this.consumidor = await this.apiconsumidor.getById(id);
    console.log(this.consumidor);
  }


  periodoPesquisa(periodo: any) {
    this.tipoPesquisa = periodo;
  }

  ativaDatas() {
    this.mostrarData = true;
  }

  desativaDatas() {
    this.mostrarData = false;
  }


  async loadPedidos() {
    const dataAtual = this.dataAtualFormatada.replace(/\-/gi, '');
    const mesPassado = this.dataMesPassadoFormatada.replace(/\-/gi, '');
    const mesPassado6 = this.data6MesPassadoFormatada.replace(/\-/gi, '');
    const anoPassado1 = this.data1AnoPassadoFormatada.replace(/\-/gi, '');

    const dia15Passado = this.data15diaPassadoFormatada.replace(/\-/gi, '');
    const dia15Passado365 = this.data15dias2.replace(/\-/gi, '');

    const dataMesPassado356 = this.dataMesPassado2.replace(/\-/gi, '');

  
    const data6MesPassado365 = this.data6MesPassado2.replace(/\-/gi, '');
    const data1AnoPassado365 = this.data1AnoPassado2.replace(/\-/gi, '');

    switch (this.tipoPesquisa) {
      case "mes":
        this.dataaux1 = mesPassado + '235959';
        this.dataaux2 = dataMesPassado356 + '000000';

        console.log(this.dataaux1);
        console.log(this.dataaux2);
        break;


      case "mes6":
        this.dataaux1 = mesPassado6 + '235959';
        this.dataaux2 =  data6MesPassado365 + '000000';
        
        console.log(this.dataaux1);
        console.log(this.dataaux2);
        break;

      case "ano1":
          this.dataaux1 = anoPassado1 + '235959';
          this.dataaux2 = data1AnoPassado365 + '000000';
          
          console.log(this.dataaux1);
          console.log(this.dataaux2);
      break;

      case "dia15":
        this.dataaux1 = dia15Passado + '235959';
        this.dataaux2 = dia15Passado365 + '000000';
        console.log(this.dataaux1);
        console.log(this.dataaux2);
      break;
    }


  }


  gerarPdf() {
    const data1 = this.dataaux1;
    const data2 = this.dataaux2;
    const tipo = this.tipoPedido2;
    const tipo2 = this.tipoPesquisa;

    this.router.navigate(['/gerar-ranking-ociosos/' + data1 + '/' + data2 + '/' + tipo + '/' + tipo2 + '']);
  }






  async loadStatus() {

    let statusaux1 = [
      { name: 'Abertos', code: '1' },
      { name: 'Em Emissão', code: '2' },
      { name: 'Em Produção', code: '3' },
      { name: 'Em Entrega', code: '4' },
      { name: 'Finalizados', code: '5' },
      { name: 'Cancelados', code: '6' }
    ];

    let statusaux2 = [
      { name: 'Todos', code: 'todos' },
      { name: 'Abertos', code: '1' },
      { name: 'Em Emissão', code: '2' },
      { name: 'Em Produção', code: '3' },
      { name: 'Em Entrega', code: '4' },
      { name: 'Finalizados', code: '5' },
      { name: 'Cancelados', code: '6' }
    ];

    if (this.tipoRelatorio === "prod" || this.tipoRelatorio === "prod2" || this.tipoRelatorio === "cliente") {
      this.status = statusaux1.map(c => {
        return ({ label: c.name, value: c.code });
        // tslint:disable-next-line: align
      })
    } else {
      this.status = statusaux2.map(c => {
        return ({ label: c.name, value: c.code });
        // tslint:disable-next-line: align
      })
    }

  }






  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    //this.loadPedidos(this.tipoPedido);
    this.loadPedidos();
  }

  async doSearchBarChange($event: any) {
    const value = $event.target.value;
    //this.pedidos = await this.pedidoapi.GetByNome(value);
  }


}
